<div class="content">
    <label *ngIf="labelOn">{{ label }}</label>
    <mat-form-field appearance="outline" *ngIf="labelOn">
        <input #googleMapsSearcher matInput placeholder="">
    </mat-form-field>
    <div class="map" #map></div>
</div>